import(/* webpackMode: "eager", webpackExports: ["ImgSlider"] */ "/vercel/path0/apps/web/app/_components/blocks/imgSlider/ImgSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb","BreadcrumbList","BreadcrumbItem","BreadcrumbBack","BreadcrumbSeparator","BreadcrumbPage"] */ "/vercel/path0/apps/web/app/_components/ui/breadcrumb.tsx");
